import axios from 'axios';
import Cookies from 'js-cookie';
import { ACCESS_TOKEN_COOKIE } from './auth.api';

export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

export const configure = () => {
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        const message = (error.response.data as any)?.message;

        if (message === 'Invalid or expired token') {
          Cookies.remove(ACCESS_TOKEN_COOKIE);
          window.location.reload();
        }
      }

      return Promise.reject(error);
    },
  );

  apiClient.interceptors.request.use(
    (config) => {
      const token = Cookies.get('access_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );
};
